import './article-social.scss';

/**
 * version    1.0
 * class      <type> (ArticleSocial)
 * classdesc
 */
export class ArticleSocial {}
